// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"bfcfbbd0","200":"8bae27b0","330":"81520dfc","421":"a9cba300","436":"a37ad24b","442":"bc86eecd","563":"0817760a","572":"1ff62bd3","587":"0055d0a0","622":"32abc240","645":"76a1fc53","727":"41879a6b","785":"74a449d2","881":"3738682c","961":"95373a92"}[chunkId] + ".chunk.js";
};